import moment from "moment";
import { StatsPeriods } from "../../../components/pages/connected/Dashboard/DashboardResults/DashboardResults.types";

export const getStatPeriodDate = (boostHistory: { period: StatsPeriods, stat_date: Date }) => {
  const { period, stat_date } = boostHistory

  switch (period) {
    case StatsPeriods.Day:
      return moment(stat_date).format('DD/MM/YYYY')
    case StatsPeriods.Week:
      return `${moment(stat_date).weekday(0).format('DD/MM/YYYY')} - ${moment(stat_date).weekday(6).format('DD/MM/YYYY')}`
    case StatsPeriods.Month:
      return moment(stat_date).format('MMMM YYYY')
  }
}